import React from 'react';

const GeneralEditContext = React.createContext({
    anyFieldChanged: undefined,
    countryCode: undefined,
    countryCodeError: undefined,
    firstName: undefined,
    language: undefined,
    lastName: undefined,
    onCancelClick: undefined,
    onCountryCodeChange: undefined,
    onFirstNameChange: undefined,
    onLastNameChange: undefined,
    onPhoneChange: undefined,
    onSaveClick: undefined,
    phone: undefined,
    phoneError: undefined,
    phoneDisabled: undefined,
    saveButtonDisabled: undefined,
});

GeneralEditContext.displayName = 'GeneralEditContext';

export default GeneralEditContext;
